import React from "react";
import useTimeout from "../use-timeout/use-timeout";
import { useNotificationStore } from "@/zustand/notificationsStore";

type CopyState = "READY" | "SUCCESS" | Error;

const useClipboard = ({ delay = 2000 } = {}) => {
  const [state, setState] = React.useState<CopyState>("READY");

  const timeout = useTimeout(() => setState("READY"), delay);
  const { success, error } = useNotificationStore((state) => state);

  function handleCopyResult(result: CopyState, message?: string) {
    setState(result);

    if (result instanceof Error) {
      error("Failed to copy to clipboard");
    } else {
      success(message ?? "Copied");
    }

    timeout.call();
  }

  function copy(valueToCopy: string, message?: string) {
    if ("clipboard" in navigator) {
      navigator.clipboard
        .writeText(valueToCopy)
        .then(() => handleCopyResult("SUCCESS", message))
        .catch((error) => error instanceof Error && handleCopyResult(error));
    } else {
      handleCopyResult(
        new Error("`useClipboard`: Navigation Clipboard is not supported")
      );
    }
  }

  return { copy, state };
};

export default useClipboard;
